import { DialogContentText } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import LinearProgress from '@mui/material/LinearProgress'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  contentText: string
  onCancel: () => void
  onConfirm: () => Promise<void>
  isLoading: boolean
  showDialog: boolean
  confirmIsDangerous?: boolean
}

export type ConfirmDialogInputProps = {
  title: string
  contentText: string
  onConfirm: () => Promise<void>
  confirmIsDangerous: boolean
}

export default function ConfirmDialog({
  title,
  contentText,
  onCancel,
  onConfirm,
  isLoading,
  showDialog,
  confirmIsDangerous,
}: Props): JSX.Element {
  const { t } = useTranslation()

  return (
    <>
      {showDialog ? (
        <Dialog open={!!showDialog} maxWidth="sm" fullWidth>
          {isLoading && <LinearProgress />}
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{contentText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={isLoading} onClick={onCancel}>
              {t('cancel')}
            </Button>
            <Button
              variant="contained"
              disabled={isLoading}
              onClick={onConfirm}
              color={confirmIsDangerous ? 'error' : 'primary'}
            >
              {t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <></>
      )}
    </>
  )
}
